module.exports = __webpack_public_path__ + "static/img/7.cccc4a2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/8/1/3/eng/7.png
// module id = 3+/R
// module chunks = 0